module.exports = __webpack_public_path__ + "static/media/js-icon.82f4b91e.png";